import { render } from "./OrderDetailLadingBill.vue?vue&type=template&id=c2c022d4&scoped=true&ts=true"
import script from "./OrderDetailLadingBill.vue?vue&type=script&lang=ts"
export * from "./OrderDetailLadingBill.vue?vue&type=script&lang=ts"

import "./OrderDetailLadingBill.vue?vue&type=style&index=0&id=c2c022d4&lang=sass&scoped=true"
import "./OrderDetailLadingBill.vue?vue&type=style&index=1&id=c2c022d4&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c022d4"]])

export default __exports__